<template>
  <article class="map-wrapper">
    <div class="container">
      <p class="text0">오시는 길</p>
      <div class="map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3230.191474886573!2d126.99986575471658!3d37.53821128797768!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca3b21ed0cd5d%3A0x654d19be7077c57!2z7ISc7Jq47Yq567OE7IucIOyaqeyCsOq1rCDtlZzrgqjrj5kg7J207YOc7JuQ66GcIDI2OC0yMA!5e0!3m2!1sko!2skr!4v1633069509641!5m2!1sko!2skr"
          width="600"
          height="450"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
        ></iframe>
      </div>
      <div class="address">
        <p><span>캐럿글로벌 :</span>서울특별시 용산구 한남동 이태원로 268-20</p>
        <p>
          <span>캐럿솔루션즈 :</span>서울특별시 서초구 강남대로 479 신논현타워
          6F
        </p>
      </div>
    </div>
  </article>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.map-wrapper {
  padding: 40px 0;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .text0 {
    font-size: 33px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 26px;

    @media screen and (min-width: 1350px) {
      font-size: 50px;
      margin-bottom: 52px;
    }
  }

  .map {
    margin-bottom: 23px;

    @media screen and (min-width: 1350px) {
      margin-bottom: 46px;
    }

    iframe {
      width: 100%;
    }
  }

  .address {
    p {
      font-size: 20px;

      &:nth-of-type(1) {
        margin-bottom: 10px;
      }

      span {
        font-weight: 700;
      }
    }
  }
}
</style>
